import React from 'react';
import HeroHeader from '../components/HeroHeader';
import RentalsSection from '../components/RentalsSection';
import BookingSection from '../components/BookingSection';
import ProcessSection from '../components/ProcessSection';

function Rentals() {
  return (
    <div>
      <HeroHeader />
      <RentalsSection />
      <BookingSection />
      <ProcessSection />
    </div>
  )
}

export default Rentals